import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import SEOHead from '@/components/SEOHead';
import Header from '@/components/layout/Header';
import Footer from '@/components/layout/Footer';

const BOOKING_URL = 'https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ1t6kd1aJ-Zaxjdd-7hbwwUZ87lIIZvYC_PDVWu_g46xzt2fdNBZDIbIvESPrJsHDbx0LJTrMJq';

const Booking = () => {
  return (
    <div className="min-h-screen bg-background">
      <SEOHead
        title="Book a Free Discovery Call | Video Production Columbus Ohio | Vantage Point Media"
        description="Schedule your free discovery call with Vantage Point Media in Columbus Ohio. Discuss video production, social media management, and content strategy for your business."
        canonical="https://vantagepointmediagroup.com/booking"
      />
      <Header />
      <main className="pt-28 pb-20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <Link to="/" className="inline-flex items-center gap-2 text-muted-foreground hover:text-foreground transition-colors mb-8">
            <ArrowLeft className="w-4 h-4" />
            Back to Home
          </Link>

          <div className="text-center mb-12">
            <h1 className="font-display font-bold text-3xl sm:text-4xl lg:text-5xl text-foreground mb-4">
              Book Your <span className="text-primary">Discovery Call</span>
            </h1>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              Schedule your free consultation to discuss how we can help grow your business.
            </p>
          </div>

          <div className="max-w-3xl mx-auto rounded-2xl overflow-hidden border border-border bg-card" style={{ minHeight: '900px' }}>
            <iframe
              src={BOOKING_URL}
              className="w-full border-none"
              style={{ minHeight: '900px', height: '100%' }}
              title="Book a Discovery Call"
            />
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Booking;
